var map = {
	"./a-emporter.svg": 33,
	"./arrow-down.svg": 68,
	"./arrow-left-white.svg": 24,
	"./arrow-left.svg": 69,
	"./avatar.svg": 34,
	"./bar-chart.svg": 35,
	"./bill.svg": 36,
	"./cart.svg": 37,
	"./categ/boulangerie.svg": 70,
	"./categ/burger.svg": 71,
	"./categ/cafe.svg": 72,
	"./categ/crepe.svg": 73,
	"./categ/glace.svg": 74,
	"./categ/pizza.svg": 75,
	"./categ/plat.svg": 76,
	"./checked.svg": 25,
	"./delete.svg": 14,
	"./envelope.svg": 31,
	"./fire.svg": 38,
	"./home.svg": 30,
	"./left-arrow-white.svg": 9,
	"./left-arrow.svg": 8,
	"./livraison-a-domicile.svg": 39,
	"./logout.svg": 40,
	"./menu.svg": 41,
	"./minus-symbol.svg": 26,
	"./minus.svg": 42,
	"./monresto.svg": 77,
	"./paiement.svg": 43,
	"./pay-1.svg": 44,
	"./pay-2.svg": 45,
	"./pay-3.svg": 46,
	"./pay-4.svg": 47,
	"./percentage.svg": 27,
	"./pizza.svg": 78,
	"./plus-symbol.svg": 13,
	"./plus.svg": 48,
	"./retrait-au-magasin.svg": 79,
	"./search.svg": 19,
	"./sur-place.svg": 80,
	"./terminal.svg": 81,
	"./x-dark.svg": 49,
	"./x.svg": 15
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;